import ProcessingPayment from './scripts';

export default ProcessingPayment;
